
import { defineComponent } from "vue";
import { SOCIAL } from "@/constants";

export default defineComponent({
  name: "FooterSocial",
  setup() {
    return {
      SOCIAL,
    };
  },
});
